import "Validation/yup/methods";

import React, { useEffect, useState } from "react";
import { EnterpriseAccountPlan, EnterpriseDemoRequestMode } from "Services/API/API";
import { ContactUsModal, FormType, ProRequestModal } from "Components/Modal";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";

const triggerSelector = '[data-trigger="PageRequestModal"]';
const proTriggerSelector = '[data-trigger="ProRequestModal"]';

export const PageRequestModal: React.FC = () => {
   const [enterpriseRequestModalOpened, setEnterpriseRequestModalOpened] = useState(false);
   const [selectedPlan, setSelectedPlan] = useState<EnterpriseAccountPlan | undefined>(undefined);
   const [modalMode, setModalMode] = useState<EnterpriseDemoRequestMode>(EnterpriseDemoRequestMode.HP);
   const [formType, setFormType] = useState<FormType>(FormType.General);
   const [formName, setFormName] = useState<string | undefined>(undefined);

   const [proRequestModalOpened, setProRequestModalOpened] = useState(false);

   const onBtnClickEventHandler = (event) => {
      const formType = event.target?.getAttribute("data-form-type");
      if (formType) {
         setFormType(formType);
      }
      const plan: string = event.target?.getAttribute("data-plan");
      if (plan) {
         const planEmum: EnterpriseAccountPlan = EnterpriseAccountPlan[plan];
         setSelectedPlan(planEmum);
      } else {
         setSelectedPlan(undefined);
      }
      const mode: string = event.target?.getAttribute("data-mode");
      if (mode) {
         const modeEmum: EnterpriseDemoRequestMode = EnterpriseDemoRequestMode[mode];
         setModalMode(modeEmum);
      }
      const formName = event.target?.getAttribute("data-form-name");
      if (formName) {
         setFormName(formName);
      }
      toggleEnterpriseRequestModal();
   }

   const onProBtnClickEventHandler = () => {
      toggleProRequestModal();
   }

   const toggleProRequestModal = () => {
      setProRequestModalOpened((wasOpened) => !wasOpened);
   }

   const toggleEnterpriseRequestModal = () => {
      setEnterpriseRequestModalOpened((wasOpened) => !wasOpened);
   }

   const onEnterpriseRequestModalClosed = () => {
      setSelectedPlan(undefined);
   }  

   useEffect(() => {
      const triggers = document.querySelectorAll(triggerSelector);
      triggers.forEach((trigger) => {
         trigger.addEventListener("click", onBtnClickEventHandler);
      });
      const proTriggers = document.querySelectorAll(proTriggerSelector);
      proTriggers.forEach((trigger) => {
         trigger.addEventListener("click", onProBtnClickEventHandler);
      });

      return function cleaup() {
         const triggers = document.querySelectorAll(triggerSelector);
         triggers.forEach((trigger) => {
            trigger.removeEventListener("click", onBtnClickEventHandler);
         });

         const proTriggers = document.querySelectorAll(proTriggerSelector);
         proTriggers.forEach((trigger) => {
            trigger.removeEventListener("click", onProBtnClickEventHandler);
         });
      }
   }, [])

   return (<Provider store={LSStore.instance}>
      <CookiesProvider>
         {enterpriseRequestModalOpened && <ContactUsModal toggle={toggleEnterpriseRequestModal} isOpen={enterpriseRequestModalOpened} formType={formType} selectedPlan={selectedPlan} formName={formName} mode={modalMode} onClosed={onEnterpriseRequestModalClosed} centered />}
         {proRequestModalOpened && <ProRequestModal toggle={toggleProRequestModal} isOpen={proRequestModalOpened} centered />}
      </CookiesProvider>
   </Provider>)
}